module.exports = __webpack_public_path__ + "static/media/organization-icon.ac76d9fd.svg";